import { Trans } from '@lingui/react/macro';
import { ThumbsDown } from '@untitledui/icons/ThumbsDown';

import { Button, type ButtonProps } from '@/components/base/buttons/button';

interface NotInterestedButtonProps {
  onClick?: ButtonProps['onClick'];
  isDisabled?: boolean;
  size?: Extract<ButtonProps['size'], 'xs' | 'sm'>;
  className?: string;
}

export function NotInterestedButton({
  onClick,
  isDisabled,
  size = 'sm',
  className,
}: NotInterestedButtonProps) {
  return (
    <Button
      color="tertiary"
      size={size}
      className={className}
      iconLeading={ThumbsDown}
      onClick={onClick}
      isDisabled={isDisabled}
    >
      <Trans>Not interested</Trans>
    </Button>
  );
}
